import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'


const WarningPopup = ({ mail = false, goToLoginForm, close }) => {
  const { t } = useTranslation('form')
  const { replace } = useHistory()

  return (
    <Popup close={close}>
      <div className='popup__verification'>
        <i className='icon icon--logo s24' />
        <p>{t(mail ? 'emailHasAlreadyBeenUsed' : 'phoneNumberHasAlreadyBeenUsed')} {t('wouldYouLikeToLogInInstead')}</p>
        <div className='verification__buttons center'>
          <div
            className='verification__button --primary --secFont'
            onClick={() => {
              if (goToLoginForm) goToLoginForm()
              else replace('/login')
            }}>
            {t('logIn')}
          </div>
          <div
            className='verification__button'
            onClick={close}>
            {t('continue')}
          </div>
        </div>
      </div>
    </Popup>
  )
}

export default WarningPopup